'use client';
import { useEffect } from 'react';

import { useSetAtom } from 'jotai';

import { removeFromFavouritesAtom } from '@core/Atoms/Favourites/Favourites.atom';
import { fetchVehicle } from '@core/Services/Vehicle/FetchVehicle';

interface ClientVehicleCheckProps {
  vehicleId: string;
}

export const ClientVehicleCheck = ({ vehicleId }: ClientVehicleCheckProps) => {
  const removeFromFavourites = useSetAtom(removeFromFavouritesAtom);

  useEffect(() => {
    let isMounted = true;
    (async () => {
      const vehicle = await fetchVehicle(vehicleId, 'uk');
      if (!vehicle && isMounted) {
        removeFromFavourites(vehicleId);
      }
    })();
    return () => {
      isMounted = false;
    };
  }, [vehicleId, removeFromFavourites]);
  return null;
};
